<template>
  <div>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      @click="Add('null')"
      v-if="hasAuth('sys:stash:add')"
      >添加</el-button
    >
    <el-table
      ref="multipleTable"
      :data="Store_list"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="仓库名称"
        align="center"
        prop="name"
        width="200"
      />
      <el-table-column
        label="仓库类型"
        align="center"
        prop="address"
        width="160"
      >
        <template slot-scope="{ row }">
          <span v-if="row.type == 1">主仓库</span>
          <span v-if="row.type == 2">子仓库</span>
        </template>
      </el-table-column>
      <el-table-column
        label="联系方式"
        align="center"
        prop="phone"
        width="160"
      />
      <el-table-column
        label="月结卡号"
        align="center"
        prop="monthlyCust"
        width="160"
      />
      <el-table-column
        label="仓库地址"
        align="center"
        prop="address"
        min-width="200"
      />

      <el-table-column
        label="操作"
        align="center"
        prop="icon"
        fixed="right"
        width="500"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="Edit(scope.row, 1)"
            v-if="hasAuth('sys:stash:edit')"
            >编辑</el-button
          >
          <el-button
            type="info"
            plain
            @click="Area(scope.row)"
            v-if="scope.row.type == 2 && hasAuth('sys:stash:area')"
            >配送区域</el-button
          >
          <el-button
            type="warning"
            plain
            @click="Allot(scope.row)"
            v-if="
              hasAuth('sys:stash:diaodu') &&
              userInfo.username == 'admin' &&
              scope.row.type != 2
            "
            >调拨</el-button
          >
          <el-button
            type="warning"
            plain
            @click="Allot(scope.row)"
            v-if="hasAuth('sys:stash:diaodu') && userInfo.username != 'admin'"
            >调拨</el-button
          >
          <el-button
            type="success"
            plain
            @click="Stash(scope.row)"
            v-if="hasAuth('sys:stash:goods')"
            >仓库商品</el-button
          >

          <el-button
            type="danger"
            plain
            slot="reference"
            v-if="hasAuth('sys:stash:del')"
            @click="Del(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <Edit ref="refedit" @back="getList" />
    <Distr ref="refDistr" />
    <Goods ref="refGoods" />
    <Allots ref="refAllots" />
  </div>
</template>
<script>
import Edit from "./Edit.vue";
import Distr from "./Distr.vue";
import Goods from "./Goods.vue";
import Allots from "./Allots.vue";
export default {
  components: {
    Edit,
    Distr,
    Goods,
    Allots,
  },
  data() {
    return {
      Allotvisible: false,
      Store_list: [],
      userInfo: {},
    };
  },
  created() {
    this.getUserInfo();
    this.getList();
  },
  methods: {
    getUserInfo() {
      this.$axios.post("/admin/user/userInfo").then((res) => {
        this.userInfo = res.data;
      });
    },
    getList() {
      this.$axios
        .get("/admin/entrepot/getList", {
          pageNo: 1,
          pageSize: 99,
        })
        .then((res) => {
          this.Store_list = res.data.records;
        });
    },
    //仓库商品
    Stash(row) {
      this.$refs.refGoods.init(row);
    },
    //调拨
    Allot(row) {
      this.$refs.refAllots.init(row);
    },
    //添加
    Add() {
      this.$refs.refedit.init();
      this.AddVisible = true;
    },
    //配送区域
    Area(row) {
      this.$refs.refDistr.init(row);
    },
    //编辑
    Edit(row) {
      this.$refs.refedit.init(row);
    },
    //删除
    Del(id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/entrepot/del", {
            id: id,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
